<template>
    <div>
       
        <updateprofile/>
    </div>
</template>
<script>
import updateprofile from '@/components/updateprofile'
export default {
     components: {      
        updateprofile
     },
    
     data: () => ({
            name: 'Update Profile',
            
      }),
      mounted(){
           this.$parent.$children[0].$parent.ttlval = this.name
      },
      
}
</script>
<style scoped>

</style>